/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const problemQuoteDtoSchema = z.object({
  quote: z.optional(z.string()),
  sourceLabel: z.optional(z.string()),
  sourceUrl: z.optional(z.string()),
});
